import { GrainPriceInput } from './GrainPriceInput';

export default GrainPriceInput;